/**
 * Returns the given fraction in lowest terms.
 *
 * @param numerator
 * @param denominator
 * @returns {number[]}
 */
module.exports = (numerator, denominator) => {
  let gcd = function gcd(a, b){
    return b ? gcd(b, a % b) : a;
  };
  gcd = gcd(numerator, denominator);

  return [numerator / gcd, denominator / gcd];
};
